/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

export const MINUTE_TO_PIXEL_FACTOR = 12;

export const GRID_TIMEBAR_REFRESH_TIME = 1 * 1000; // 1 sec

export const HOUR_TO_MILLISEC = 60 * 60 * 1000;

export const MILLISECONDS_IN_A_MINUTE = 60 * 1000;

export const MAX_GRID_GUIDE_PROGRAM_CELL_LENGTH = 130 * 60;

export const IDLE_GRID_GUIDE_DURATION = 120;
export const IDLE_GRID_GUIDE_DURATION_IN_SECOND = 7200;

export const MILLISECONDS_IN_A_SECOND = 1000;

export const FUTURE_GUIDE_MAX_PAGE_LOAD = 12 * 14; // No. of 2 hour slot in a day * Number of Days
export const DEFAULT_PAST_GUIDE_MAX_PAGE_LOAD = 12 * 7;
export const GUIDE_HORIZONTAL_PAGE_LIMIT = 1;
export const GUIDE_VERTICAL_PAGE_LIMIT = 1;
export const GUIDE_FOCUS_HORIZONTAL_PAGE_ID = 0;
export const GUIDE_FOCUS_VERTICAL_PAGE_ID = 0;

export const CLOCK_REFRESH_RATE = 1 * 1000; // 1 second
export const SECONDS_IN_A_MINUTE = 1 * 60;

export const WHISPER_ACTIVE_TIME = 5 * 1000;

export const GUIDE_NETWORK_CALL_WAIT_DURATION = 0.5 * 1000;
export const PREVIEW_CAST_MAX_LENGTH = 80;
export const PREVIEW_TITLE_MAX_LENGTH = 150;
export const PREVIEW_TITLE_ONE_LINE_LENGTH = 75;
export const PREVIEW_TITLE_SIZE_REDUCTION_LENGTH = 47;
export const PREVIEW_DESCRIPTION_ONE_LINE_LENGTH = 80;
export const ONE_LINE_PREVIEW_DESCRIPTION = 1;
export const TWO_LINES_PREVIEW_DESCRIPTION = 2;
export const STAR_RATING_MAX_STARS = 4;

export const LAST_VIEWED_POSITION_INTERVAL_TIME = 2 * 60 * 1000;

// Timeout values
export const OVERLAY_ANIMATION_DURATION = 0.5 * 1000;

export const OVERLAY_TIMEOUT = 5 * 60 * 1000;

export const SIDEBAR_TIMEOUT = 5 * 60 * 1000;

export const TURBO_SCROLL_ANIMATION_DURATION = 0.1 * 1000;

/**
 * Timer constants
 */
export const IDLE_USER_THRESHOLD_TIME = 15 * 60 * 1000;

// MsoDefault partnerLogo size
export const PARTNER_BRANDING_LOGO_HEIGHT_1080P = 360;

export const PARTNER_BRANDING_LOGO_WIDTH_1080P = 600;

export const PRIMARY_BRANDING_LOGO_DEFAULT_HEIGHT = 90;

export const PRIMARY_BRANDING_LOGO_DEFAULT_WIDTH = 90;

/**
 * DO NOT DISTURB OR ADD ANY CONFIGURATIONS BELOW.
 */
export const ACCESS_TOKEN_BUFFER_TIME = 15 * 60 * 1000; // 15 mins

export const ACTIONS_STRIP_DEFAULT_HIGHLIGHT_INDEX = 0;

export const ACTION_STRIP_HIGHLIGHT_LEFT_OFFSET = 132;

export const APP_ENVIRONMENT = {
    PRODUCTION: 'production',
};

export const APPLICATION_FEATURE_AREA = {
    GUIDE: 'guide',
    PLAYER: 'player',
    SETTINGS: 'settings',
    STARTUP: 'startup',
    ONEPASS_OVERLAY: 'OnePassOverlay',
    ONEPASS_MANAGER: 'OnePassManagerScreen',
    SERIES_SCREEN: 'SeriesScreen',
    PROGRAM_SCREEN: 'ProgramScreen',
};

export const ASSETBOUNDS = 'Caching';

export const AVPLAY_TRACK_TYPE_TEXT = 'TEXT';

export const AVPLAY_TRACK_TYPE_AUDIO = 'AUDIO';

export const BACKDOOR_PASSCODE = '571247';

export const BUFFER_THRESHOLD_OFFSET = 9; // 9 sec

export const CALIBRATION_VALUE = 1; // used to calculate accurate quarter time.

export const CHANNEL_NUMBER_MAX_LENGTH = 5;

export const CHANNEL_TITLE_MAX_LENGTH = 49;

export const COLLECTION_SCREEN_ITEM_RESIZE_TIME = 2.5 * 1000;

export const COLLECTION_SCREEN_PREVIEW_DESCRIPTION_ONE_LINE_LENGTH = 80;

export const DASH_TRANSPORT_STREAM = '.mpd';

export const DEBUG_SCREEN_PASSCODE = '560103';

export const DEFAULT_APPLICATION_NAME = 'CableCo5';

export const DEFAULT_CONTENT_DURATION_IN_MILLISECONDS = 1.5 * 60 * 60 * 1000; // 01H30M time

export const DEFAULT_DEVICE_TYPE = 'iptvSmartTv';

export const DEFAULT_GUIDE_TASKS = 'DEFAULT_GUIDE_TASKS';

export const DEFAULT_LANDING_LOCATION_URL = '/guide';

export const DEFAULT_LANDING_SCREEN = 'GUIDE';

export const DEFAULT_LANGUAGE_INDEX = 0;

export const DEFAULT_LOCALE = 'en_US';

export const DEFAULT_MSO_NAME = 'cableco3';

export const DEFAULT_MSO_REGION = 'us';

export const DEFAULT_RETRY_OPTIONS = {
    maxRetries: 3,
    retryOn: {
        '400': {
            delayType: 'incremental',
            delay: [2000, 3000, 5000, 7000, 11000, 13000],
            retryAfterHeader: 'Retry-After',
            shouldCheckRetryAfterHeader: true,
        },
        '404': {
            delayType: 'incremental',
            delay: [2000, 3000, 5000, 7000, 11000, 13000],
            retryAfterHeader: 'Retry-After',
            shouldCheckRetryAfterHeader: true,
        },
        '500': {
            delayType: 'incremental',
            delay: [2000, 3000, 5000, 7000, 11000, 13000],
            retryAfterHeader: 'Retry-After',
            shouldCheckRetryAfterHeader: true,
        },
    },
};

export const DEFAULT_SAGE_ENDPOINT = 'https://sage-hec.oi.tivo.com:8088/services/collector/event';

export const DEFAULT_SEEK_RANGE_IN_MILLISECONDS = HOUR_TO_MILLISEC;

export const DEFAULT_SLS_DOMAIN = 'cableco5-production';

export const DEFAULT_SLS_ENDPOINTS_SERVICE_BASE_URL = 'https://production.sls.prod.tivoservice.com';

export const DEFAULT_SYSTEM_INFO_LOGGING_INTERVAL = 60 * 1000;

export const DESCRIPTION_MAX_LENGTH = 315;

export const HALF_HOUR_IN_MILLISECONDS = 30 * MILLISECONDS_IN_A_MINUTE;

export const EMPTY_STRING = '';

export const ENTER_CHANNEL_NUMBER_DISPLAY_TIME = 2 * 1000;

export const EOS_OFFSET = 2; // Stop VOD content 2 sec before

// 2 minutes in seconds: 2 * 60 * 1000;
export const EXIT_PLAYER_THRESHOLD_TIME = 2 * 60 * 1000;

export const FULL_INFO_BANNER_DISPLAY_TIME = 10 * 1000;

export const HLS_TRANSPORT_STREAM = '.m3u8';

export const IN_HOME_LOCATION_PLAYBACK_GRACE_PERIOD = 12000 * 1000; // 12000 seconds

export const INFO_BANNER_HIDE_ANIMATION_TIMEOUT_VALUE = 2 * 100;

export const KAVERI_GLOBAL_CATCH_NAME = 'KAVERI_GLOBAL_CATCH';

export const KAVERI_GLOBAL_CATCH_RETRY_LIMIT = 5;

export const LATAM_SLS_BASE_URL = 'https://production.sls.latam.tivoservice.com';

export const LEFT_QUOTE = String.fromCharCode(8216);

export const MAX_CHANNEL_NUMBER_DISPLAY_TIME = 0.5 * 1000;

export const MAX_STORAGE_LIMIT = 90;

export const MEDIA_HEALTH_EVENTS_INTERVAL = 300 * 1000;

export const MIN_CACHE_IN_MILLISECONDS = 10 * MILLISECONDS_IN_A_MINUTE;

export const MSO_CONFIGURATIONS: {
    [key: string]: {
        msoName: string;
        slsDomain: string;
        segmentKey: { [key: string]: string };
    };
} = {
    // default configuration
    default: {
        msoName: 'cableco3',
        slsDomain: 'cableco3-staging',
        segmentKey: {
            dev: 'sycPD1zKUmtIBJ4c2i9NCiZBLeeapALd',
            dev1: 'sycPD1zKUmtIBJ4c2i9NCiZBLeeapALd',
            devqe: 'sycPD1zKUmtIBJ4c2i9NCiZBLeeapALd',
            devst: 'sycPD1zKUmtIBJ4c2i9NCiZBLeeapALd',
            staging: 'ZHiXgDLJLD14GqrpgQCFYikfepFVS3IG',
            production: 'ZHiXgDLJLD14GqrpgQCFYikfepFVS3IG',
        },
    },
};

export const NO_OF_TICKMARKS = 6;

export const NO_NETWORK_OVERLAY_ERROR_CODE = 'C145';

export const ONE_LINE_GUIDE_DISPLAY_TIME = 15 * 1000;

export const OSD_MOVEMENT_TIME = 5 * 1000;

export const OSD_STILL_TIME = 1 * 60 * 1000;

export const PRIMARY_BRANDING_LOGO_HEIGHT_1080P = 48;

export const PRIMARY_BRANDING_LOGO_LIVE_TV_HEIGHT_1080P = 90;

export const PRIMARY_BRANDING_LOGO_LIVE_TV_WIDTH_1080P = 90;

export const PRIMARY_BRANDING_LOGO_LIVE_TV_HEIGHT_720P = 60;

export const PRIMARY_BRANDING_LOGO_LIVE_TV_WIDTH_720P = 60;

export const PRIMARY_BRANDING_LOGO_WIDTH_1080P = 165;

export const PROGRAM_CELL_TRAILING_ICONS_WIDTH_OFFSET = 32;

export const PROGRESS_BAR_LENGTH = 1471;

export const PROGRESS_BAR_LENGTH_720P = 981;

export const RIGHT_QUOTE = String.fromCharCode(8217);

export const SAGE_LOGGING_VERSION = '2.8.4';

export const SAML_TOKEN_BUFFER_TIME = 24 * 60 * 60 * 1000; // 24 hrs

export const SAML_TOKEN_VALIDITY = 24; // time in hours

export const SCREEN_HEIGHT = 1080;

export const SCREEN_HEIGHT_720P = 720;

export const SEEK_BACKWARD_8 = -8; // time in second

export const SEEK_FORWARD_30 = 30; // time in second

export const SESSION_MANAGER_GRACE_PERIOD = 4 * 60 * 60 * 1000; // 4 hours

export const SLS_SERVICE_BASE_URL_STAGING = 'https://production.sls.prod.tivoservice.com';

export const SLS_SERVICE_BASE_URL_USQE1 = 'https://stable.sls.dev.tivoservice.com';

export const SMOOTH_TRANSPORT_STREAM = '.ism';

export const SPEED = {
    SPEED_NORMAL: 1,
    SPEED_FASTFORWARD_1: 3,
    SPEED_FASTFORWARD_2: 18,
    SPEED_FASTFORWARD_3: 60,
    SPEED_REWIND_1: -3,
    SPEED_REWIND_2: -18,
    SPEED_REWIND_3: -60,
};
export const STANDARD_INFO_BANNER_DISPLAY_TIME = 6 * 1000;

export const STREAM_TYPE = 'IPTV';

// 3 hours 58 minutes in seconds: (3 * 60 + 58) * 60 * 1000;
export const STILL_THERE_THRESHOLD_TIME = (3 * 60 + 58) * 60 * 1000;

// 4 hours in ms
export const COMMON_TIMEOUT_INACTIVITY_THRESHOLD = 4 * 60 * 60 * 1000;

export const SUPPORTED_LOCALES = [
    { language: 'en', locale: 'en_US' },
    { language: 'es', locale: 'es_US' },
];

export const TICK_DURATION = 15; // 15 min
export const TICK_DURATION_30_MIN = 30; // 30 min
export const TICK_DURATION_1_HOUR = 60; // 60 min
export const DEFAULT_PROGRAM_DURATION = 30 * 60; // 30 min

export const TIVO_PRE_SIGN_IN_SERVICES = {
    BrandingService: 'cloudcore-branding-service',
    DeviceBindingService: 'devicebindingservice',
    IptvLoginService: 'iptv-login-service',
};

export const TIVO_SERVICES = {
    ActionDetailsService: 'cc-vod-ott-action-details',
    ActionsService: 'cloudcore-actions',
    AiringOffersService: 'cloudcore-airing',
    BodyInfoService: 'cloudcore-bodyinfo',
    BrandingUIBundleService: 'cloudcore-branding-service',
    BookmarkService: 'cloudcore-bookmarks',
    ChannelsService: 'channels-iptv',
    ChannelSettings: 'cloudcore-channel-settings',
    ChannelLogoImageHost: 'channel-logo-image-host',
    EpisodeGuideService: 'episode-guide',
    FeFavFilterService: 'fe-fav-filter',
    GridGuideService: 'cloudcore-guide',
    QuickMenuShortcut: 'quick-menu',
    ImageHost: 'image-host',
    InHomeLocationService: 'cloudcore-inhomelocation',
    InternalRatingsService: 'cloudcore-rating',
    MyShows: 'cloudcore-myshows',
    OnePassService: 'cloudcore-onepass',
    // TODO: uncomment in phase 2
    // PDChangeService: 'provisioning-data-change-service',
    PreviewsService: 'cloudcore-previews',
    RecordingsService: 'cloudcore-recordings',
    RecordingsStatusService: 'guide-recordings-status',
    SageService: 'sagesecure',
    SessionManagerService: 'session-manager-lambda',
    VodSocuLastViewedPositionService: 'vod-socu-last-viewed-position',
    VPConfigurationsService: 'cloudcore-provider-config',
    MyWanIpService: 'httpsinsecurexff',
    UpcomingOffersService: 'upcoming-offers',
    UserSettingsService: 'cloudcore-usersettings',
    WatchStickinessService: 'watch-stickiness',
};

export const TIZEN_PLATFORM = 'Tizen';

export const TRICK_PLAY_DISPLAY_TIME = 6 * 1000;

export const TRICKPLAY_BAR_KEY_DISPATCH_INTERVAL_TIME = 0.1 * 1000;

export const UP_NEXT_TITLE_MAX_LENGTH = 39;

export const VIDEO_PLAYER = 'ShakaPlayer';
